import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";

import { managedLiveReportLinksQueryKey } from "./useManagedLiveReportLinks";
import { removeManagedLiveReportViewer } from "../../client/manager/live-report";
import { useTixologiTokenRefresher } from "./useTixologiTokenRefresher";

interface RemoveViewerVariables {
  id: number;
  email: string;
}

export function useRemoveManagedLiveReportViewer(
  partnerId: string | undefined,
  isComedian = false
): UseMutationResult<void, Error, RemoveViewerVariables> {
  const queryClient = useQueryClient();
  const { token, refresh } = useTixologiTokenRefresher(partnerId, isComedian);

  return useMutation({
    mutationFn: async ({ id, email }: RemoveViewerVariables) => {
      const initial = token ?? (await refresh());
      if (!initial) throw new Error("Tixologi token not available");
      return removeManagedLiveReportViewer(initial, id, email, refresh);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managedLiveReportLinksQueryKey(partnerId),
      });
    },
  });
}
